import React, { useEffect, useState } from 'react';
import TitleBar from './TitleBar';
import DetailCard, { AssessmentCompanyType, InterviewedByType, InterviewedOnType } from './DetailCard';
import RoundScorecard from './RoundScorecard';
import { useLocation, useNavigate } from 'react-router-dom';
import Container from '../shared/Container';
import { GetMeetingScoreCardAPIResponse, MeetingStatus } from 'types';
import MeetingRecordingModal from './MeetingRecordingModal';
import { useUserContext } from 'src/context/UserProvider';

interface Props {
	scorecardTitle: string;
	interviewedBy?: InterviewedByType;
	interviewedOn?: InterviewedOnType;
	assessmentBy?: AssessmentCompanyType;
	data: {
		meetingScore: number;
		skillScores: GetMeetingScoreCardAPIResponse['allMeetingSkillScores'];
		status: MeetingStatus | undefined;
		meetingId: string;
	};
}

const ScorecardContainer = ({ scorecardTitle, interviewedBy, interviewedOn, data }: Props) => {
	const navigate = useNavigate();
	const { pathname } = useLocation();
	const { isGuestUser } = useUserContext();

	const [isMeetingRecordingModalOpen, setIsMeetingRecordingModalOpen] = useState<boolean>(false);

	const handleViewRecording = () => {
		setIsMeetingRecordingModalOpen(true);
	};
	const handleBackArrow = () => {
		console.log("isGuestUser",isGuestUser)
		if (isGuestUser) {
			navigate('/placed-hiring-assessment/all-assessments');
		} else {
			navigate('/assessments');
		}
	};
	return (
		<>
			<Container>
				{!pathname.includes('/interviews/live/') ? (
					<div className="mt-[18px]">
						<TitleBar handleBackArrow={handleBackArrow} title={scorecardTitle} />
					</div>
				) : null}

				{interviewedBy && interviewedOn ? (
					<div className="mt-4">
						<DetailCard
							interviewedBy={interviewedBy}
							interviewedOn={interviewedOn}
							status={data.status}
							handleViewRecording={handleViewRecording}
							meetingScore={data.meetingScore}
							meetingId={data?.meetingId}
							skillScores={data.skillScores}
						/>
					</div>
				) : null}
				{/* {assessmentBy ? (
					<div className="mt-4">
						<DetailCard
							assessmentBy={assessmentBy}
							status={data.status}
							handleViewRecording={handleViewRecording}
							meetingScore={data.meetingScore}
							meetingId={data?.meetingId}
							skillScores={data.skillScores}
						/>
					</div>
				) : null} */}

				{data?.skillScores?.length ? (
					<div className="mt-4 mb-6">
						<RoundScorecard meetingScore={data.meetingScore} skillScores={data.skillScores} />
					</div>
				) : null}
			</Container>

			<MeetingRecordingModal
				isOpen={isMeetingRecordingModalOpen}
				onClose={() => setIsMeetingRecordingModalOpen(false)}
				meetingId={data.meetingId}
			/>
		</>
	);
};

export default ScorecardContainer;
